import BlButtonGroupMv from './BlButtonGroupMv.vue'

BlButtonGroupMv.install = function(Vue) {
  Vue.component(BlButtonGroupMv.name, BlButtonGroupMv)
}

export default BlButtonGroupMv
